const colors = {
  black: '#000000',
  black10: 'rgba(0, 0, 0, 0.1)',
  black15: 'rgba(0, 0, 0, 0.15)',

  bgColor: '#14141A',
  bgColor90: 'rgba(20, 20, 26, 0.9)',
  bgColor1: '#060912',

  primary: '#001264',
  secondary: '#F04923',

  error: '#F04923',
  error12: 'rgba(240, 73, 35, 0.12)',

  primaryText: '#FDFDFD',
  primaryText8: 'rgba(253, 253, 253, 0.08)',
  primaryText10: 'rgba(253, 253, 253, 0.1)',
  primaryText12: 'rgba(253, 253, 253, 0.12)',
  primaryText20: 'rgba(253, 253, 253, 0.2)',
  primaryText35: 'rgba(253, 253, 253, 0.35)',

  primaryTextDark: '#050505',
  primaryTextDark4: 'rgba(5, 5, 5, 0.04)',
  primaryTextDark6: 'rgba(5, 5, 5, 0.06)',
  primaryTextDark12: 'rgba(5, 5, 5, 0.12)',
  primaryTextDark20: 'rgba(5, 5, 5, 0.2)',
  primaryTextDark30: 'rgba(5, 5, 5, 0.3)',

  white: '#FFFFFF',
  white10: 'rgba(255, 255, 255, 0.1)',
  white20: 'rgba(255, 255, 255, 0.2)',
  white25: 'rgba(255, 255, 255, 0.25)',
  white50: 'rgba(255, 255, 255, 0.5)',
};

export { colors };
